export default __webpack_public_path__ + "static/dataAnalysis-e3b323847272ced6c4b052a2a5bd1e97.svg";